// DEC-004: <Gate> API simple sin anyOf/allOf. Ver DECISIONES.md.
//
// La IMPLEMENTACIÓN del Gate vive ahora en @fiado/react-kit (UI pura, permisos inyectables).
// Este archivo es un wrapper tipado: re-expone el Gate del kit con los tipos del catálogo de la
// app (Permission/Scope derivados del OpenAPI) para que los 27 call-sites mantengan el chequeo
// de tipos. El chequeo de permisos en runtime lo alimenta <PermissionsProvider> desde useAuth
// (ver src/routes/_authenticated/_layout.tsx). La lógica (hasPermission/scopeCovers) NO se
// duplica aquí: sigue en useAuth.
import type { ReactNode } from 'react';
import { Gate as KitGate } from '@fiado/react-kit';
import type { Permission, Scope } from '../../api/types/permissions';

interface Props {
    permission: Permission;
    scope?: Scope;
    scopeRef?: string;
    fallback?: ReactNode;
    children: ReactNode;
}

export function Gate({ permission, scope, scopeRef, fallback = null, children }: Props) {
    return (
        <KitGate permission={permission} scope={scope} scopeRef={scopeRef} fallback={fallback}>
            {children}
        </KitGate>
    );
}
